module.exports = __webpack_public_path__ + "static/media/cd-tisne.1101abbc.jpg";